import { Dispatch } from 'redux';

import {
  ACTION_DELETE_BB_USER,
  ACTION_DELETE_BB_USER_SUCCESS,
  ACTION_DELETE_BB_USER_FAILURE,
  ACTION_RESET_DELETE_BB_USER,
  API_CALL,
} from '../../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../../Status';

export function deleteBBUser(bbUserId: string | number) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_DELETE_BB_USER,
      payload: null,
    });

    dispatch({
      type: API_CALL,
      payload: {
        call: `Users/${bbUserId}`,
        method: 'delete',
        data: null,
        success: (response: { payload: { id: string | number } }) => {
          dispatch(requestSuccess(response));
          enqueueSnackbarHandler(
            dispatch,
            { deleteBBuserSuccess: true },
            'success',
          );
        },
        fail: (error: { payload: { userPermissionError?: boolean } }) => {
          if (error.payload?.userPermissionError) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { deleteBBuserFailed: true },
              'error',
            );
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function resetDeleteBBUser() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_RESET_DELETE_BB_USER,
      payload: null,
    });
  };
}

function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_DELETE_BB_USER_SUCCESS,
    payload: responseJSON,
  };
}

function requestFailed(responseJSON: object) {
  return {
    type: ACTION_DELETE_BB_USER_FAILURE,
    payload: responseJSON,
  };
}
